import { render, staticRenderFns } from "./indicator-item-groups.vue?vue&type=template&id=1cda016e&"
import script from "./indicator-item-groups.vue?vue&type=script&lang=js&"
export * from "./indicator-item-groups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports